import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const val = control.value;
    if (val === null || val === undefined) return null;
    if (typeof val === 'string' && val.length > 0 && val.trim().length === 0) {
      return { required: true, whitespace: true };
    }
    return null;
  };
}

export function wholeNumberValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '') return null;
  return Number.isSafeInteger(Number(value)) ? null : { wholeNumber: true };
}

export function winnersWithinParticipants(control: AbstractControl): ValidationErrors | null {
  const participants = Number(control.parent?.get('no_of_users')?.value);
  const winners = Number(control.value);
  return participants > 0 && winners > participants
    ? { exceedsParticipants: true }
    : null;
}

/**
 * The prizes are announced after the campaign ends. The picker greys out earlier dates, but a
 * copied or reopened campaign loads its saved dates as they are, so the form checks them too.
 */
export function prizeAfterEndDate(control: AbstractControl): ValidationErrors | null {
  const end = control.parent?.get('end_date')?.value;
  if (!control.value || !end) return null;
  const prizeTime = new Date(control.value).getTime();
  const endTime = new Date(end).getTime();
  if (Number.isNaN(prizeTime) || Number.isNaN(endTime)) return null;
  return prizeTime > endTime ? null : { beforeEndDate: true };
}

export function normalizeAgeSelection(values: string[], previous: string[]): string[] {
  if (!values.includes('All') || values.length <= 1) return values;
  return previous.includes('All') ? values.filter(value => value !== 'All') : ['All'];
}

/** Whether the selection names an age group, rather than All or nothing. */
export function hasAgeGroup(values: unknown): boolean {
  return Array.isArray(values) && values.some(value => !!value && value !== 'All');
}

/**
 * Age Restriction on means an age group is picked. All is no restriction, and
 * it is also what a campaign with the toggle off saves, so it can't stand for one.
 */
export function ageGroupRequired(control: AbstractControl): ValidationErrors | null {
  return hasAgeGroup(control.value) ? null : { required: true };
}

export function isSupportedCampaignImage(file: Pick<File, 'name' | 'type'>): boolean {
  return /\.(png|jpe?g)$/i.test(file.name)
    && ['image/png', 'image/jpeg'].includes(file.type.toLowerCase());
}
